import { Loading } from '@components'
import { For, Suspense } from 'solid-js'
import { useService } from 'solid-services'
import { cx } from 'styled-system/css'
import { Box } from 'styled-system/jsx'
import { grid } from 'styled-system/patterns'
import { scrollbar } from 'styled-system/recipes'
import SetupCard from '../../Setups/List/Card'
import { useSetups } from './state'

export default function () {
  const { currentSetups } = useService(useSetups)()

  return (
    <Box
      class={cx(scrollbar(), grid({
        height: 'calc(var(--vh) * 100 - 142px)',
        overflowY: 'auto',
        gridTemplateColumns: {
          base: 'repeat(auto-fill, minmax(250px, 1fr))',
        },
        gap: 3,
        gridAutoRows: "max-content",
        alignContent: "start",
        p: 3
      }))}
    >
      <Suspense fallback={<Loading fill />}>
        <For each={currentSetups()()}>
          {(item) => (
            <SetupCard
              hideEditButton
              layout="image"
              setup={item as any}
            />
          )}
        </For>
      </Suspense>
    </Box>
  )
}
